var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useEffect, useState, useCallback } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Collapse from '@material-ui/core/Collapse';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Alert from '@material-ui/lab/Alert';
import clsx from 'clsx';
import axios from 'axios';
import { useForm, useBaseI18n, useAlert, useUpdateOnSubmit } from '../hooks';
import { withForm } from '../functions';
import FormCheckBox from './FormCheckBox';
import FormSelect from './FormSelect';
import FormInput from './FormInput';
import FormDate from './FormDate';
import FormImage from './FormImage';
import { base64ImageRegex } from '../constants';
var Popup = function (_a) {
    var _b = _a.requiredValues, requiredValues = _b === void 0 ? {} : _b, successMessageGenerator = _a.successMessageGenerator, errorGenerator = _a.errorGenerator, setPopup = _a.setPopup, setRows = _a.setRows, propsHandlePost = _a.handlePost, propsOnSubmit = _a.onSubmit, row = _a.row, deleteUrl = _a.deleteUrl, postUrl = _a.postUrl, rows = _a.rows, open = _a.open, content = _a.content, columns = _a.columns, disabledFields = _a.disabledFields, _c = _a.className, className = _c === void 0 ? "" : _c;
    var _d = useState(''), errorContent = _d[0], setErrorContent = _d[1];
    var _e = useState(false), error = _e[0], setError = _e[1];
    var classes = useStyles();
    var genericTable = useBaseI18n(function (i18n) { return i18n.genericTable; });
    var form = useForm();
    var alert = useAlert();
    var mode = useMemo(function () { return (content === null || content === void 0 ? void 0 : content.mode) || 'edit'; }, [content.mode]);
    var disabled = useMemo(function () { return content.mode === 'delete'; }, [content.mode]);
    var url = useMemo(function () { return mode === "delete" && deleteUrl || postUrl; }, [deleteUrl, postUrl, mode]);
    var popUpTitle = useMemo(function () {
        return genericTable[mode] + " " + content.title;
    }, [mode, content.title, genericTable]);
    var closePopUp = function () { return setPopup(false); };
    var isDisabled = useCallback(function (fieldId) {
        return disabled || (row === null || row === void 0 ? void 0 : row.isEditable) !== undefined && !(row === null || row === void 0 ? void 0 : row.isEditable) && (disabledFields === null || disabledFields === void 0 ? void 0 : disabledFields.includes(fieldId)) && content.mode === 'edit';
    }, [disabled, row, disabledFields]);
    var handlePost = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    if (propsHandlePost)
                        return [2 /*return*/, (propsHandlePost(), closePopUp())];
                    if (!url)
                        return [2 /*return*/, (spliceRows(values), closePopUp())];
                    return [4 /*yield*/, axios.post(url, content.mode === 'delete' ? JSON.stringify(values) : __assign(__assign({}, values), (values.imagePath ? {
                            files: true,
                            imagePath: base64ImageRegex.test(values.imagePath) || values.imagePath
                        } : {})))];
                case 1:
                    response = _b.sent();
                    if (response.data)
                        spliceRows(response.data);
                    closePopUp();
                    if (successMessageGenerator)
                        alert(successMessageGenerator(mode, (_a = response.data) !== null && _a !== void 0 ? _a : values), 'success');
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _b.sent();
                    if (!errorGenerator)
                        return [2 /*return*/];
                    setErrorContent(errorGenerator(error_1));
                    return [2 /*return*/, setError(true)];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (mode === 'delete')
                        return [2 /*return*/, handlePost(form.values)];
                    return [4 /*yield*/, form.setFieldValue('requiredValues', (_a = requiredValues[mode]) !== null && _a !== void 0 ? _a : null)];
                case 1:
                    _b.sent();
                    form.handleSubmit();
                    return [2 /*return*/];
            }
        });
    }); };
    var spliceRows = function (data) {
        var Rows = __spreadArray([], rows);
        var index = content.idx;
        if (index > -1) {
            if (mode === "edit") {
                Rows[index] = data;
            }
            else /*delete*/
                Rows.splice(index, 1);
        }
        else /*add*/
            Rows.push(data);
        setRows(Rows);
    };
    var displayInPopUp = function (column) {
        var _a;
        var index = (_a = column === null || column === void 0 ? void 0 : column.hiddenOn) === null || _a === void 0 ? void 0 : _a.filter(function (elm) { return elm === mode; });
        return !(index && index.length);
    };
    useEffect(function () {
        form.setValues(function (values) { return (__assign(__assign({}, values), row)); });
    }, []);
    useUpdateOnSubmit(handlePost);
    return (_jsx(Dialog, __assign({ className: classes.dialogContainer + " " + className, open: open, onClose: closePopUp }, { children: _jsxs("div", { children: [_jsx(DialogTitle, __assign({ className: classes.formDialogTitle }, { children: popUpTitle }), void 0),
                _jsxs("form", { children: [_jsxs(DialogContent, { children: [_jsx("label", { children: content.label }, void 0),
                                columns.filter(function (elm) { return displayInPopUp(elm); }).map(function (column, index) {
                                    if (column.type === 'select' && column.options)
                                        return (_jsx(FormSelect, { id: column.field, options: column.options, description: column.title, disabled: isDisabled(column.field) }, index));
                                    if (column.type === 'checkbox')
                                        return (_jsx(FormCheckBox, { id: column.field, description: column.title, readOnly: isDisabled(column.field) }, index));
                                    if (column.type === 'date')
                                        return (_jsx(FormDate, { id: column.field, description: column.title, readOnly: isDisabled(column.field) }, index));
                                    if (column.type === "image") {
                                        return (_jsx(FormImage, { id: 'image', classes: column.classes, readonly: isDisabled(column.field) }, void 0));
                                    }
                                    if (column.type === "text") {
                                        return (_jsx(FormInput, { id: column.field, description: column.title, multiline: true, rows: 2, inputProps: {
                                                maxLength: 350
                                            }, readOnly: isDisabled(column.field) }, void 0));
                                    }
                                    if (column.type === "phone") {
                                        return (_jsx(FormInput, { id: column.field, description: column.title, inputProps: {
                                                maxLength: 10
                                            }, readOnly: isDisabled(column.field) }, void 0));
                                    }
                                    return (_jsx(FormInput, { id: column.field, description: column.title, type: column.type, readOnly: isDisabled(column.field) }, index));
                                }),
                                _jsx(Collapse, __assign({ "in": error }, { children: _jsx(Alert, __assign({ severity: "error" }, { children: errorContent }), void 0) }), void 0)] }, void 0),
                        _jsxs(DialogActions, __assign({ className: classes.dialogActions }, { children: [_jsx(Button, __assign({ onClick: closePopUp, className: classes.button }, { children: genericTable.cancel }), void 0),
                                _jsx(Button, __assign({ onClick: onSubmit, className: clsx(classes.button, classes.okBtn), color: "primary" }, { children: genericTable.ok }), void 0)] }), void 0)] }, void 0)] }, void 0) }), void 0));
};
export default withForm()(Popup);
var useStyles = makeStyles(function (theme) { return ({
    dialogContainer: {
        fontFamily: 'Assistant-Regular',
        color: theme.palette.primary.main,
        '& label': {
            fontFamily: 'Assistant-Regular',
            color: theme.palette.primary.main
        },
        '& input:not([type:"file"])': {
            width: '19rem',
            height: '2rem',
            backgroundColor: '#F2F2F2',
            border: 'none',
            display: 'block',
            outline: 'none'
        }
    },
    dialogActions: {
        flex: '0 0 auto',
        display: 'flex',
        padding: '1rem',
        width: '20rem',
        alignItems: 'center',
        justifyContent: 'flex-end'
    },
    formDialogTitle: {
        fontFamily: 'Assistant-Regular',
        color: theme.palette.primary.main,
        '& h2': {
            fontFamily: 'Assistant-Regular',
            fontWeight: 900
        }
    },
    button: {
        fontWeight: 'bold',
        fontFamily: 'Assistant-Regular',
        borderRadius: 8,
        color: theme.palette.primary.main
    },
    okBtn: {
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        width: '5rem',
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
            backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.3) 0 0)'
        }
    }
}); });
//# sourceMappingURL=Popup.js.map